import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  formCierreCuentas: ["payload"],
  formCierreCuentasLoading: null,
  formCierreCuentasSuccess: ["formCierreCuentasData"],

  formConsultaCierresCuentas: ["payload"],
  formConsultaCierresCuentasLoading: null,
  formConsultaCierresCuentasSuccess: ["formConsultaCierresCuentasData"],

  consultarIngreso: ["payload"],
  consultarIngresoLoading: null,

  consultarDetalleCierreCuenta: ["payload"],
  consultarDetalleCierreCuentaLoading: null,

  getProcedimientosPermitidosCierreCuentas: ["payload"],
  getProcedimientosPermitidosCierreCuentasLoading: null,

  validarProcedimientoCierreCuentas: ["payload"],
  validarProcedimientoCierreCuentasLoading: null,

  eliminarProcedimientoCierreCuentas: ["payload"],
  eliminarProcedimientoCierreCuentasLoading: null,

  consultarReclamantes: ["payload"],
  consultarReclamantesLoading: null,

  cerrarCuentaClinica: ["payload"],
  cerrarCuentaClinicaLoading: null,

  consultarCierresCuentas: ["payload"],
  consultarCierresCuentasLoading: null,
});

export { Types };

export default Creators;
